const { prop } = require('ramda');
module.exports = (value) =>
  prop('enabled')(value) ? 'Enabled' : 'Not Enabled';
